import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useCurrentFormAuditId } from 'src/context/FormContext/CurrentFormAuditContext'
import {
  BasicDropdownMenuItem,
  BasicDropdownMenu,
} from 'src/components/Reusable/BasicDropdown/BasicDropdown.styles'
import { ReactComponent as VerticalEllipsesIcon } from '../../../../components/Icons/assets/vertical-ellipses-icon.svg'
import { DropdownToggleButton } from '../../../../components/Reusable/Buttons'
import { useDownloadSoc2Report } from '../../../GRCDashboards/Compliance/Download/hooks'
import { CloseAudit } from './CloseAudit'
import { DownloadWorkPapers } from './DownloadWorkPapers'
import { ControlsCSV } from './ControlsCSV'
import { EditAudit } from './EditAudit'
import { UploadFinalReport } from './UploadFinalReport'
import { DownloadFinalReport } from './DownloadFinalReport'
import { DeleteAudit } from './DeleteAudit'

type AuditIndexItemMenuProps = {
  auditId: string
  isClosed: boolean
  //todo - replace with report type
  hasProForma: boolean
}

const proFormaOptions = new Set(['Pro Forma SOC 2 Report (.pdf)'])

export const ItemMenu = ({
  auditId,
  isClosed,
  hasProForma,
}: AuditIndexItemMenuProps): JSX.Element => {
  const { setAuditId } = useCurrentFormAuditId()
  const openHandler = () => setAuditId(auditId)

  const closed = [
    {
      key: 'Delete Audit',
      item: <DeleteAudit />,
    },
    {
      key: 'Work papers (.zip)',
      item: (
        <DownloadWorkPapers eventKey={'Work papers (.zip)'} auditId={auditId} />
      ),
    },
    {
      key: 'Upload Final Audit Report',
      item: (
        <UploadFinalReport
          eventKey={'Upload Final Audit Report'}
          auditId={auditId}
        />
      ),
    },
    {
      key: 'Download Stored Audit Report',
      item: (
        <DownloadFinalReport
          eventKey={'Download Stored Audit Report'}
          auditId={auditId}
        />
      ),
    },
  ]

  const open = [
    {
      key: 'Edit',
      item: <EditAudit eventKey={'Edit'} auditId={auditId} />,
    },
    {
      key: 'Close Audit',
      item: <CloseAudit eventKey={'Close Audit'} auditId={auditId} />,
    },
    {
      key: 'Delete Audit',
      item: <DeleteAudit />,
    },
    {
      key: 'Divider',
      item: <Dropdown.Divider />,
    },
    {
      key: 'Pro Forma SOC 2 Report (.pdf)',
      item: (
        <BasicDropdownMenuItem
          eventKey={'Pro Forma SOC 2 Report (.pdf)'}
          onClick={useDownloadSoc2Report(auditId)}
        >
          Pro Forma SOC 2 Report (.pdf)
        </BasicDropdownMenuItem>
      ),
    },
    {
      key: 'Work papers (.zip)',
      item: (
        <DownloadWorkPapers eventKey={'Work papers (.zip)'} auditId={auditId} />
      ),
    },
    {
      key: 'Controls (.csv)',
      item: <ControlsCSV eventKey={'Controls (.csv)'} auditId={auditId} />,
    },
  ]

  const options = isClosed ? closed : open

  return (
    <Dropdown id={`audit-index-menu-${auditId}`} onClick={openHandler}>
      <Dropdown.Toggle as={DropdownToggleButton} id={`audit-menu-${auditId}`}>
        <VerticalEllipsesIcon />
      </Dropdown.Toggle>
      <BasicDropdownMenu>
        {options.map((entry) => {
          if (!hasProForma && proFormaOptions.has(entry.key)) {
            return <></>
          }
          return <span key={entry.key}>{entry.item}</span>
        })}
      </BasicDropdownMenu>
    </Dropdown>
  )
}
